import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { composePathWithParams } from "../../utils/url";
import { ROUTES } from "../../routing/routes";
import { Category } from "../../data/interfaces";

// -----------------------------------------------------------------
// I n t e r f a c e s
// -----------------------------------------------------------------
interface Props {
  category: Category;
}

const CategoryBox = ({ category, ...restProps }: Props) => {
  // -----------------------------------------------------------------
  // L o c a l   v a r s
  // -----------------------------------------------------------------
  // Access to the history instance that you may use to navigate.
  let history = useHistory();

  // -----------------------------------------------------------------
  // N a v i g a t i o n   v a r s
  // -----------------------------------------------------------------

  // -----------------------------------------------------------------
  // S t a t e
  // -----------------------------------------------------------------

  // -----------------------------------------------------------------
  // R e f s  (DOM)
  // -----------------------------------------------------------------

  // -----------------------------------------------------------------
  // u s e S e l e c t o r   m e t h o d s  (redux)
  // -----------------------------------------------------------------

  // -----------------------------------------------------------------
  // W o r k i n g   m e t h o d s
  // -----------------------------------------------------------------
  const goToCategory = (): void => {
    history.push(composePathWithParams(ROUTES.CATEGORY_DETAIL, [{ id: category.id }]));
  };

  // -----------------------------------------------------------------
  // R e n d e r   m e t h o d s
  // -----------------------------------------------------------------

  // -----------------------------------------------------------------
  // L i f e c y c l e
  // -----------------------------------------------------------------
  /**
   * This method is called the first time the component is mounted
   * @function
   */
  const init = (): void => {
    console.log("[CategoryBox] init");
  };

  /**
   * This method is called when the component is unmounted
   * @function
   */
  const destroy = (): void => {
    console.log("[CategoryBox] destroy");
    // destroy all
  };

  // -----------------------------------------------------------------
  // u s e E f f e c t   m e t h o d s
  // -----------------------------------------------------------------
  /**
   * This hook is called once when the component is mounted
   */
  useEffect(() => {
    init();
    return () => {
      destroy();
    };
  }, []);

  // -----------------------------------------------------------------
  // T e m p l a t e
  // -----------------------------------------------------------------
  return (
    <div className="category chip" style={{ background: category.color }} onClick={goToCategory}>
      <h3 style={{ color: category.text_color }}>{category.name}</h3>
    </div>
  );
};
export default CategoryBox;
